import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';
import { TShowDetails } from '@r1-frontend/survey/context/reducer/initialState';

import { IAction } from '@r1-frontend/shared/types/Redux';

const start = (payload: TShowDetails): IAction<SurveyActions.Start, TShowDetails> => ({
    type: SurveyActions.Start,
    payload,
});

export default start;
